<template>
  <div class="app-container">
    <el-button size="medium" type="primary" style="margin-bottom: 20px;" @click="dialogCreateVisible = true">Add</el-button>
    <el-select v-model="listQuery.disabled" :placeholder="'老師狀態'" style="width: 90px" class="filter-item" @change="handleFilter">
      <el-option v-for="item in disableOpitons" :key="item.value" :label="item.label" :value="item.value" />
    </el-select>
    <el-table v-loading="listLoading" :data="list" fit highlight-current-row style="width: 100%">
      <el-table-column align="center" label="ID" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.number }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Name" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="E-mail" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.email }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Phone" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Country" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.countryName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Time Zone" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.timezone }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Status" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.disabled | disableTrans }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="" width="250">
        <template slot-scope="scope">
          <el-button type="success" size="small" @click="edit(scope.row)">Edit</el-button>
          <el-button type="danger" size="small" @click="remove(scope.row.id, scope.row.number)">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
    <CreateDialog :dialog-create-visible-prop="dialogCreateVisible" />
    <EditDialog :dialog-edit-visible-prop="dialogEditVisible" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import CreateDialog from '@/views/accounts/teacher/create'
import EditDialog from '@/views/accounts/teacher/edit'
import UserResource from '@/api/user'

const userResource = new UserResource()
var moment = require('moment-timezone');

export default {
  name: 'TeacherList',
  components: { Pagination, CreateDialog, EditDialog },
  filters: {
    disableTrans(status) {
      if (status === 1) {
        return '封鎖'
      } else {
        return '正常'
      }
    }
  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        disabled: 2
      },
      dialogCreateVisible: false,
      dialogEditVisible: false,
      disableOpitons: [
        { 'value': 0, 'label': '正常' },
        { 'value': 1, 'label': '封鎖' },
        { 'value': 2, 'label': '全部' }
      ],
      countries: [],
      timezones: [],
      currentEditItem: null,
      currentEditId: 0,
      errorCodeMessage: {
        0: { 'type': 'success', 'title': ' Success', 'message': ' Success' },
        12: { 'type': 'error', 'title': 'Something went wrong', 'message': 'Please try again. (Error Code 12)' },
        13: { 'type': 'error', 'title': 'Something went wrong', 'message': 'Please try again. (Error Code 13)' },
        23: { 'type': 'warning', 'title': 'Warning', 'message': 'Please try again. (Error Code 23)' }
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.listLoading = true
      const { data } = await userResource.teacherLists(this.listQuery)
      this.list = data.items
      this.total = data.total
      this.countries = data.countries
      this.timezones = moment.tz.names();
      this.listLoading = false
    },
    edit(item) {
      this.currentEditItem = item
      this.dialogEditVisible = true
    },
    remove(id, number) {
      this.$confirm('Are you sure to want to Delete this ? Number:' + number, 'Tip', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'
      }).then(() => {
        this.sendData(id)
      }).catch(() => {
        return false
      })
    },
    async sendData(id) {
      const { data } = await userResource.removeTeacher(id)
      const actionTitle = 'Delete'
      if (data.code === 0) {
        this.messageNotify(
          actionTitle + this.errorCodeMessage[data.code]['title'],
          this.errorCodeMessage[data.code]['message'],
          this.errorCodeMessage[data.code]['type']
        )
        this.getList()
      } else {
        this.messageNotify(
          actionTitle + this.errorCodeMessage[data.code]['title'],
          this.errorCodeMessage[data.code]['message'],
          this.errorCodeMessage[data.code]['type']
        )
        return false
      }
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    messageNotify(title, message, type) {
      this.$notify({
        title: title,
        dangerouslyUseHTMLString: true,
        message: `<div>${message}</div>`,
        type: type
      })
    }
  }
}
</script>

<style scoped>
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.el-table {
  position: inherit!important;
}
</style>
